import React, { ReactElement, ReactNode } from 'react';
import { useFormikContext, getIn } from 'formik';
import { Form } from 'react-bootstrap';

export type PropsDeCheckbox<T> = {
    id: keyof T;
    titre?: ReactNode;
    cacherTitre?: boolean;
    titreEstLabel?: boolean;
    style?: React.CSSProperties;
    isChecked?: boolean;
    notifyChange?: (newValue: boolean) => void;
    hideFormGroup?: boolean;
};

export default function CheckboxFormulaire<T>(props: PropsDeCheckbox<T>): ReactElement {
    const { titre, id, cacherTitre, titreEstLabel, style, notifyChange } = props;
    const { handleChange, values, touched, errors } = useFormikContext<T>();
    const onChangeHandler = (event: any) => {
        handleChange(event);
        if (notifyChange) {
            notifyChange(event.target.checked);
        }
    };
    const getInValue = getIn(values, id.toString());
    const getInTouched = getIn(touched, id.toString());
    const getInErrors = getIn(errors, id.toString());

    const content = (
        <>
            {titreEstLabel && !cacherTitre ? <Form.Label>{titre}</Form.Label> : null}
            {props.isChecked !== undefined ? (
                <Form.Check
                    type="checkbox"
                    id={id.toString()}
                    name={id.toString()}
                    onChange={onChangeHandler}
                    checked={props.isChecked}
                    isInvalid={getInTouched && !!getInErrors}
                    feedback={getInErrors}
                    label={!cacherTitre && !titreEstLabel && titre}
                    style={props.hideFormGroup ? props.style : undefined}
                />
            ) : (
                <Form.Check
                    type="checkbox"
                    id={id.toString()}
                    name={id.toString()}
                    onChange={onChangeHandler}
                    defaultChecked={!!getInValue}
                    isInvalid={getInTouched && !!getInErrors}
                    feedback={getInErrors}
                    label={!cacherTitre && !titreEstLabel && titre}
                    style={props.hideFormGroup ? props.style : undefined}
                />
            )}
        </>
    );

    return (
        <>
            {props.hideFormGroup ? (
                <>{content}</>
            ) : (
                <Form.Group controlId={id as string} style={style}>
                    {content}
                </Form.Group>
            )}
        </>
    );
}
